var _defs, _path, _line, _circle, _path2, _line2, _circle2, _circle3, _circle4, _line3, _line4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew247({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4,7.47a2,2,0,1,1,4,0"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 4.01,
    y1: 7.47,
    x2: 4.01,
    y2: 10.05
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 4.01,
    cy: 9.97,
    r: 0.61
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12,7.42a2,2,0,1,0-4,0"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 11.99,
    y1: 7.42,
    x2: 11.99,
    y2: 10
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 11.99,
    cy: 9.92,
    r: 0.61
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 1.92,
    cy: 7.78,
    r: 1.49
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 14.08,
    cy: 7.78,
    r: 1.49
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 1.92,
    y1: 6.29,
    x2: 14.08,
    y2: 6.29
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 1.92,
    y1: 9.27,
    x2: 14.08,
    y2: 9.27
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew247);
export default __webpack_public_path__ + "static/media/Symbolpack_New_247.986608c2e7d5fa9e6c077d563d1958a8.svg";
export { ForwardRef as ReactComponent };